import { ExpensesManagmentService } from './client-core/services/expenses-managment.service';
import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing'
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';

// Core providers
import { CoreModule } from "./core/core.module";
import { SmartadminLayoutModule } from "./shared/layout/layout.module";
import { AuthInterceptor } from "./core/interceptors/auth.interceptor";

import { ModalModule } from 'ngx-bootstrap/modal';
import { CampaignService } from './client-core/services/campaign.service';
import { UserService } from './client-core/services/user.service';
import { BrandService } from './client-core/services/brand.service';
import { RetailerService } from './client-core/services/retailer.service';
import { SectorService } from './client-core/services/sector.service';
import { DocumentService } from './client-core/services';
import { ProgramService } from './client-core/services/program.service';
import { TacticService } from './client-core/services/tactic.service';
import { LoaderInterceptor } from './core/interceptors/loading.interceptor';
import { SiteSetupService } from './client-core/services/site-setup';
import { CustomizationService } from './client-core/services/customization.service';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { StrategicBusinessInitiativeService } from './client-core/services/strategic-business-initiative.service';
import { FiscalYearService } from './client-core/services/fiscal-year.service';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxMultiLineEllipsisModule } from 'ngx-multi-line-ellipsis';
import { TasksService } from './client-core/services/tasks.service';
import { ReportService } from './client-core/services/report.service';
import { ExcelService } from './client-core/services/excel.service';
import { DashboardService } from './client-core/services/dashboard.service';
import { ExportAsModule } from 'ngx-export-as';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NewCampaignService } from './client-core/services/new-campaign-service';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ReportsService } from './client-core/services/reports.service';
import { CategoriesService } from './client-core/services/categories.service';
import { ClientSettingsService } from './client-core/services/client-settings.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CCRContactService } from './client-core/services/ccrcontact.service';

//import { TacticCatalogModule } from './';

// Application wide providers
const APP_PROVIDERS = [
    ...APP_RESOLVER_PROVIDERS,
    AppState
];

type StoreType = {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent
    ],
    imports: [ // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ModalModule.forRoot(),
        CoreModule,
        SmartadminLayoutModule,
        routing,
        NgxSpinnerModule,
        SelectDropDownModule,
        UiSwitchModule,
        NgxMultiLineEllipsisModule,
        ExportAsModule,
        AngularFontAwesomeModule,
        SlickCarouselModule,
        PdfViewerModule,
    ],
    exports: [
    ],
    providers: [ // expose our Services and Providers into Angular's dependency injection
        // ENV_PROVIDERS,
        APP_PROVIDERS,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true
        },
        CampaignService,
        DocumentService,
        UserService,
        BrandService,
        RetailerService,
        SectorService,
        ProgramService,
        TacticService,
        SiteSetupService,
        CustomizationService,
        StrategicBusinessInitiativeService,
        FiscalYearService,
        ExpensesManagmentService,
        TasksService,
        ReportService,
        ExcelService,
        DashboardService,
        NewCampaignService,
        ReportsService,
        CategoriesService,
        ClientSettingsService,
        CCRContactService,
        { provide: Window, useValue: window }
    ]
})
export class AppModule {
    constructor(public appRef: ApplicationRef, public appState: AppState) { }
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts